export default "__VITE_ASSET__7184dab8__"